/* eslint-disable import/prefer-default-export */
/* No need for default export of enum */
export enum IconColors {
    Action = 'var(--color-Action)',
    ActionInverse = 'var(--color-ActionInverse)',
    BorderLight = 'var(--color-BorderLight)',
    DarkGrey = 'var(--color-DarkGrey)',
    DeclinedRed = 'var(--color-DeclinedRed)',
    Grey = 'var(--color-Grey)',
    LightGrey = 'var(--color-LightGrey)',
    MediumGrey = 'var(--color-MediumGrey)',
    OffWhite = 'var(--color-OffWhite)',
    PageBorder = 'var(--color-PageBorder)',
    PECOOrange = 'var(--color-PECOOrange)',
    SuccessGreen = 'var(--color-SuccessGreen)',
    SuccessGreenSecondary = 'var(--color-SuccessGreenSecondary)',
    Text = 'var(--color-Text)',
    TextLight = 'var(--color-TextLight)',
    TextMedium = 'var(--color-TextMedium)',
    Warning = 'var(--color-Warning)',
    WarningRed = 'var(--color-WarningRed)',
    WarningRedSecondary = 'var(--color-WarningRedSecondary)',
    White = 'var(--color-White)',
}
